import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemNameSelector =
  (bomItemId: string, preferTreeView?: boolean) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId, preferTreeView)

    if (!bomItem?.type) {
      return null
    }
    switch (bomItem?.type) {
      case 'Assembly':
      case 'Row':
        return bomItem.name
      case 'MaterialHeader':
        return bomItem.materialSummary.description
      default:
        return bomItem.id
    }
  }
